import {AverageEnergyResponse} from '../../../../api/models/average-energy-response';
import {AverageEnergyStatus} from '../../../../api/models/average-energy-status';

/** Measured series returned by the API. */
export type MeasuredEnergyKey =
  | 'production'
  | 'consumption'
  | 'consumptionPositive'
  | 'consumptionNegative'
  | 'batteryCharge'
  | 'batteryPower'
  | 'batteryPowerPositive'
  | 'batteryPowerNegative'
  | 'grid'
  | 'gridPositive'
  | 'gridNegative'
  | 'all';

/** Forecast counterpart of every measured series ("production" -> "plannedProduction"). */
export type PlannedEnergyKey =
  | 'plannedProduction'
  | 'plannedConsumption'
  | 'plannedConsumptionPositive'
  | 'plannedConsumptionNegative'
  | 'plannedBatteryCharge'
  | 'plannedBatteryPower'
  | 'plannedBatteryPowerPositive'
  | 'plannedBatteryPowerNegative'
  | 'plannedGrid'
  | 'plannedGridPositive'
  | 'plannedGridNegative'
  | 'plannedAll';

export type AverageEnergyKey = MeasuredEnergyKey | PlannedEnergyKey;

export function getAverageEnergyStatus(
  data: AverageEnergyResponse | undefined,
  key: AverageEnergyKey,
): AverageEnergyStatus | undefined {
  return data?.values?.[key];
}

/** The planned key belonging to a measured key, e.g. "gridPositive" -> "plannedGridPositive". */
export function plannedKeyOf(key: MeasuredEnergyKey): PlannedEnergyKey {
  return `planned${key.charAt(0).toUpperCase()}${key.slice(1)}` as PlannedEnergyKey;
}

/**
 * The forecast series belonging to a measured series. Days in the future only
 * carry planned values, today usually carries both.
 */
export function getPlannedEnergyStatus(
  data: AverageEnergyResponse | undefined,
  key: MeasuredEnergyKey,
): AverageEnergyStatus | undefined {
  return getAverageEnergyStatus(data, plannedKeyOf(key));
}
